import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminOrganizationsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('organization');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
